import { baseSchemaProperties } from '../base-schema-properties'
import {
  titleSchemaProperties,
  blockShadowSchemaProperties,
  titleSizeSchemaProperties,
} from '../common'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Latest News',
  description: 'Block with list of news',
  type: 'object',
  properties: {
    ...baseSchemaProperties,
    ...titleSchemaProperties,
    ...titleSizeSchemaProperties,
    ...blockShadowSchemaProperties,
    viewAllLink: {
      title: 'View all link',
      type: 'string',
      default: '/news',
    },
    viewAllText: {
      title: 'View all text',
      type: 'string',
      default: 'View all',
    },
  },
}
